import React from 'react';
import { Navbar } from './Components/Navbar';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import { Home, HomePage } from './Pages/HomePage';
import { BioPage } from './Pages/BioPage';
import { GalleryPage } from './Pages/GalleryPage';
import { TourPage } from './Pages/TourPage';
import { ContactPage } from './Pages/ContactPage';






function App() {
  return (
    <div>
      <BrowserRouter >
      <Navbar />
      <Routes>
      <Route path='/' element={<HomePage/>}/>
      <Route path='BioPage' element={<BioPage/>}/>
      <Route path='GalleryPage' element={<GalleryPage/>}/>
      <Route path='TourPage' element={<TourPage/>}/>
      <Route path='ContactPage' element={<ContactPage/>}/>
      
  
      
      

      </Routes>
      

      </BrowserRouter>
     
      
      
    </div>
  );
}

export default App;
